import type { FeGridSettings, VirtualPreset } from '../types/Api';
import type { EagColumnState } from '../types/EagColumnState';
import { getPresetStates } from './getPresetStates';

/**
 * Builds a VirtualPreset from the current column states, grid settings, and a data query ID.
 * Delegates the columnsSettings mapping to getPresetStates to avoid duplication.
 */
export function buildActivePreset(dataQueryId: string, columnStates: EagColumnState[], settings: FeGridSettings): VirtualPreset {
  return {
    gridSettings: settings,
    columnsSettings: getPresetStates(columnStates),
    dataQueryId
  };
}